import { render, staticRenderFns } from "./inner-model.vue?vue&type=template&id=decaa944&"
import script from "./inner-model.vue?vue&type=script&lang=js&"
export * from "./inner-model.vue?vue&type=script&lang=js&"
import style0 from "./inner-model.vue?vue&type=style&index=0&id=decaa944&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports